<div class="unauthorized-container light-modern">
  <h1 class="unauthorized-title">Page Introuvable</h1>
  <p class="unauthorized-message">Oops! That page doesn’t exist.</p>
  <button class="home-button" (click)="router.navigate(['/'])">
    Go to Home
  </button>
</div>
